import React from "react";
import '../assets/styles/Project.scss';

function Publication() {
    return(
    <div className="projects-container" id="publications">
        <h1>Publications</h1>

        {/* ── IEEE ── */}
        <div className="pub-section">
            <h3 className="pub-section-label pub-label-ieee">IEEE</h3>
            <div className="projects-grid projects-grid-3">

                <div className="project">
                    <a href="https://ieeexplore.ieee.org/document/11012102" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Migrating Traditional Applications to Cloud-Native DevOps: A Framework for Successful Cloud Migration and Modernization</span>
                        </div>
                    </a>
                    <a href="https://ieeexplore.ieee.org/document/11012102" target="_blank" rel="noreferrer">
                        <h2>Migrating Traditional Applications to Cloud-Native DevOps: A Framework for Successful Cloud Migration and Modernization</h2>
                    </a>
                    <p>13th International Symposium on Digital Forensics and Security (ISDFS 2025), Boston &mdash; IEEE</p>
                </div>

                <div className="project">
                    <a href="https://ieeexplore.ieee.org/document/11500622" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">AI and Automation in Cloud DevOps &mdash; Transforming Monitoring, Security, and Infrastructure Management</span>
                        </div>
                    </a>
                    <a href="https://ieeexplore.ieee.org/document/11500622" target="_blank" rel="noreferrer">
                        <h2>AI and Automation in Cloud DevOps &mdash; Transforming Monitoring, Security, and Infrastructure Management</h2>
                    </a>
                    <p>International Conference on Business Intelligence for Technology Innovation (ICBITI 2025) &mdash; IEEE</p>
                </div>

                <div className="project">
                    <a href="https://ieeexplore.ieee.org/document/11484430" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Adaptive Cloud-Native Architectures for Scalable and Energy-Efficient Smart Manufacturing Systems</span>
                        </div>
                    </a>
                    <a href="https://ieeexplore.ieee.org/document/11484430" target="_blank" rel="noreferrer">
                        <h2>Adaptive Cloud-Native Architectures for Scalable and Energy-Efficient Smart Manufacturing Systems</h2>
                    </a>
                    <p>2026 Innovations in Machine, Engineering, and Digital Conference (IMED 2026) &mdash; IEEE</p>
                </div>

            </div>
        </div>

        {/* ── Springer ── */}
        <div className="pub-section">
            <h3 className="pub-section-label pub-label-springer">Springer</h3>
            <div className="projects-grid">

                <div className="project">
                    <a href="https://www.actsoft.org/esda2024/index.html" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Harnessing Retrieval-Augmented Generation (RAG) For Intelligent Information Retrieval in AI Systems</span>
                        </div>
                    </a>
                    <a href="https://www.actsoft.org/esda2024/index.html" target="_blank" rel="noreferrer">
                        <h2>Harnessing Retrieval-Augmented Generation (RAG) For Intelligent Information Retrieval in AI Systems</h2>
                    </a>
                    <p>Energy System Drives and Automation (ESDA) Conference 2024 &mdash; Springer</p>
                </div>

                <div className="project">
                    <a href="https://www.actsoft.org/esda2024/index.html" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Support Vector Machines in Practice: Optimizing AI for Real-Time Decision Making</span>
                        </div>
                    </a>
                    <a href="https://www.actsoft.org/esda2024/index.html" target="_blank" rel="noreferrer">
                        <h2>Support Vector Machines in Practice: Optimizing AI for Real-Time Decision Making</h2>
                    </a>
                    <p>Energy System Drives and Automation (ESDA) Conference 2024 &mdash; Springer</p>
                </div>

            </div>
        </div>

        {/* ── Scientific Reports — Peer-Reviewed ── */}
        <div className="pub-section">
            <h3 className="pub-section-label pub-label-nature">Scientific Reports &mdash; Springer Nature (Peer-Reviewed)</h3>
            <div className="projects-grid">

                <div className="project">
                    <a href="https://www.nature.com/articles/s41598-025-15292-2" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Hybrid Deep Learning-Enabled Framework for Enhancing Security, Data Integrity, and Operational Performance in Healthcare Internet of Things (H-IoT) Environments</span>
                        </div>
                    </a>
                    <a href="https://www.nature.com/articles/s41598-025-15292-2" target="_blank" rel="noreferrer">
                        <h2>Hybrid Deep Learning-Enabled Framework for Enhancing Security, Data Integrity, and Operational Performance in Healthcare Internet of Things (H-IoT) Environments</h2>
                    </a>
                    <p>Scientific Reports, Springer Nature &mdash; Published</p>
                </div>

                <div className="project">
                    <a href="https://www.nature.com/srep/" target="_blank" rel="noreferrer">
                        <div className="pub-slide">
                            <span className="pub-slide-text">Explainable AI-Driven Deep Learning for Auto Scaling of Virtual Network Functions with Inter-VNF Dependency in Cloud-Native Environments</span>
                        </div>
                    </a>
                    <a href="https://www.nature.com/srep/" target="_blank" rel="noreferrer">
                        <h2>Explainable AI-Driven Deep Learning for Auto Scaling of Virtual Network Functions with Inter-VNF Dependency in Cloud-Native Environments</h2>
                    </a>
                    <p>Scientific Reports, Springer Nature &mdash; Yet to be Published</p>
                </div>

            </div>
        </div>

    </div>
    );
}

export default Publication;
